import React from "react";

const ToggleButton = ({ setValue, value, title, storge }) => {
    const onCheck = () => {
        let newVal = !value;
        storge && localStorage.setItem(storge, newVal ? "1" : "0");
        setValue(newVal);
    };
    return (
        <div className={`Toggle-button self-start cursor-pointer ${value ? "Toggleed" : ""}`}>
            <p onClick={onCheck} className="Toggleed-bg shadow-1">
                <span className="shadow-1" />
            </p>
            <p className="font-bold carbonic flex-grow">{title}</p>
        </div>
    );
};

export default ToggleButton;
